(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Overlay"] = factory();
	else
		root["Overlay"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/scripts/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/scripts/CustomEvents/ClickEvent.js":
/*!************************************************!*\
  !*** ./src/scripts/CustomEvents/ClickEvent.js ***!
  \************************************************/
/*! exports provided: ClickEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClickEvent", function() { return ClickEvent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//--------------------------\\
//---- ClickEvent Class ----\\
//--------------------------\\
var ClickEvent = /*#__PURE__*/function () {
  function ClickEvent(instance) {
    _classCallCheck(this, ClickEvent);

    this.instance = instance;
    this.openButtons = [];
    this.closeButtons = [];
    this.toogleButtons = [];
    this.triggerButtons = [];
    this.switchButtons = [];
  } // ----------------------------------------------------------------------------------------------------------------------------
  // Initialization of all click events
  // ----------------------------------------------------------------------------------------------------------------------------


  _createClass(ClickEvent, [{
    key: "init",
    value: function init() {
      var _this = this;

      var i;
      var doc = document; // The open click event

      if (this.instance.overlay.click.buttons.open !== undefined) {
        this.openButtons = Array.prototype.slice.call(doc.querySelectorAll(this.instance.overlay.click.buttons.open));
        var openButtonsLength = this.openButtons.length;

        for (i = 0; i < openButtonsLength; i++) {
          this['boundOpen' + i] = function (e) {
            return _this.instance.open(e);
          };

          this.openButtons[i].addEventListener('click', this['boundOpen' + i], false);
        }
      } // The close click event


      if (this.instance.overlay.click.buttons.close !== undefined) {
        this.closeButtons = Array.prototype.slice.call(doc.querySelectorAll(this.instance.overlay.click.buttons.close));
        var closeButtonsLength = this.closeButtons.length;

        for (i = 0; i < closeButtonsLength; i++) {
          this['boundClose' + i] = function (e) {
            return _this.instance.close({
              element: e,
              keepScrollDisabled: false
            });
          };

          this.closeButtons[i].addEventListener('click', this['boundClose' + i], false);
        }
      } // The toggle click event


      if (this.instance.overlay.click.buttons.toggle !== undefined) {
        this.toogleButtons = Array.prototype.slice.call(doc.querySelectorAll(this.instance.overlay.click.buttons.toggle));
        var toogleButtonsLength = this.toogleButtons.length;

        for (i = 0; i < toogleButtonsLength; i++) {
          this['boundToogle' + i] = function (e) {
            return _this.instance.toggle(e);
          };

          this.toogleButtons[i].addEventListener('click', this['boundToogle' + i], false);
        }
      } // The trigger click event


      if (this.instance.overlay.click.buttons.trigger !== undefined) {
        this.triggerButtons = Array.prototype.slice.call(doc.querySelectorAll(this.instance.overlay.click.buttons.trigger));
        var triggerButtonsLength = this.triggerButtons.length;

        for (i = 0; i < triggerButtonsLength; i++) {
          this['boundTrigger' + i] = function (e) {
            return _this.instance.trigger(e);
          };

          this.triggerButtons[i].addEventListener('click', this['boundTrigger' + i], false);
        }
      } // The switch click event


      if (this.instance.overlay.click.buttons.switch !== undefined) {
        this.switchButtons = Array.prototype.slice.call(doc.querySelectorAll(this.instance.overlay.click.buttons.switch));
        var switchButtonsLength = this.switchButtons.length;

        for (i = 0; i < switchButtonsLength; i++) {
          this['boundSwitch' + i] = function (e) {
            return _this.instance.switch(e);
          };

          this.switchButtons[i].addEventListener('click', this['boundSwitch' + i], false);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Add more buttons for the event
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "add",
    value: function add(selectors) {
      var _this2 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'open';
      var i;
      var doc = document;
      var typeWithCapital = type.charAt(0).toUpperCase() + type.slice(1);

      if (selectors !== undefined) {
        var buttonsAlreadyThereLength = this[type + 'Buttons'].length;
        var newButtons = Array.prototype.slice.call(doc.querySelectorAll(selectors));
        var newButtonsLength = newButtons.length;

        for (i = 0; i < newButtonsLength; i++) {
          this[type + 'Buttons'].push(newButtons[i]);
        }

        var buttonsLength = this[type + 'Buttons'].length;

        for (i = buttonsAlreadyThereLength; i < buttonsLength; i++) {
          if (type === 'close') this['boundClose' + i] = function (e) {
            return _this2.instance.close({
              element: e,
              keepScrollDisabled: false
            });
          };else this['bound' + typeWithCapital + i] = function (e) {
            return _this2.instance[type](e);
          };
          this[type + 'Buttons'][i].addEventListener('click', this['bound' + typeWithCapital + i], false);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Destroying all click events
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "destroy",
    value: function destroy() {
      var i; // The open click event

      if (this.instance.overlay.click.buttons.open !== undefined) {
        var openButtonsLength = this.openButtons.length;

        for (i = 0; i < openButtonsLength; i++) {
          this.openButtons[i].removeEventListener('click', this['boundOpen' + i], false);
        }
      } // The close click event


      if (this.instance.overlay.click.buttons.close !== undefined) {
        var closeButtonsLength = this.closeButtons.length;

        for (i = 0; i < closeButtonsLength; i++) {
          this.closeButtons[i].removeEventListener('click', this['boundClose' + i], false);
        }
      } // The toggle click event


      if (this.instance.overlay.click.buttons.toggle !== undefined) {
        var toogleButtonsLength = this.toogleButtons.length;

        for (i = 0; i < toogleButtonsLength; i++) {
          this.toogleButtons[i].removeEventListener('click', this['boundToogle' + i], false);
        }
      } // The trigger click event


      if (this.instance.overlay.click.buttons.trigger !== undefined) {
        var triggerButtonsLength = this.triggerButtons.length;

        for (i = 0; i < triggerButtonsLength; i++) {
          this.triggerButtons[i].removeEventListener('click', this['boundTrigger' + i], false);
        }
      } // The switch click event


      if (this.instance.overlay.click.buttons.switch !== undefined) {
        var switchButtonsLength = this.switchButtons.length;

        for (i = 0; i < switchButtonsLength; i++) {
          this.switchButtons[i].removeEventListener('click', this['boundSwitch' + i], false);
        }
      }
    }
  }]);

  return ClickEvent;
}();

/***/ }),

/***/ "./src/scripts/CustomEvents/MouseoverEvent.js":
/*!****************************************************!*\
  !*** ./src/scripts/CustomEvents/MouseoverEvent.js ***!
  \****************************************************/
/*! exports provided: MouseoverEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MouseoverEvent", function() { return MouseoverEvent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//------------------------------\\
//---- MouseoverEvent class ----\\
//------------------------------\\
var MouseoverEvent = /*#__PURE__*/function () {
  function MouseoverEvent(instance) {
    _classCallCheck(this, MouseoverEvent);

    this.instance = instance;
    this.openButtons = [];
    this.closeButtons = [];
    this.triggerButtons = [];
  } // ----------------------------------------------------------------------------------------------------------------------------
  // Initialization of all mouseover events
  // ----------------------------------------------------------------------------------------------------------------------------


  _createClass(MouseoverEvent, [{
    key: "init",
    value: function init() {
      var _this = this;

      var i;
      var doc = document; // The open click event

      if (this.instance.overlay.mouseover.buttons.open !== undefined) {
        this.openButtons = doc.querySelectorAll(this.instance.overlay.mouseover.buttons.open);
        var openButtonsLength = this.openButtons.length;

        for (i = 0; i < openButtonsLength; i++) {
          this['boundOpen' + i] = function (e) {
            return _this.instance.open(e);
          };

          this.openButtons[i].addEventListener('mouseover', this['boundOpen' + i], false);
        }
      } // The close click event


      if (this.instance.overlay.mouseover.buttons.close !== undefined) {
        this.closeButtons = doc.querySelectorAll(this.instance.overlay.mouseover.buttons.close);
        var closeButtonsLength = this.closeButtons.length;

        for (i = 0; i < closeButtonsLength; i++) {
          this['boundClose' + i] = function (e) {
            return _this.instance.close({
              element: e,
              keepScrollDisabled: false
            });
          };

          this.closeButtons[i].addEventListener('mouseover', this['boundClose' + i], false);
        }
      } // The trigger click event


      if (this.instance.overlay.mouseover.buttons.trigger !== undefined) {
        this.triggerButtons = doc.querySelectorAll(this.instance.overlay.mouseover.buttons.trigger);
        var triggerButtonsLength = this.triggerButtons.length;

        for (i = 0; i < triggerButtonsLength; i++) {
          this['boundTrigger' + i] = function (e) {
            return _this.instance.trigger(e);
          };

          this['boundResetTimeout' + i] = function (e) {
            return _this.instance.resetTimeout(e);
          };

          this.triggerButtons[i].addEventListener('mouseover', this['boundTrigger' + i], false);
          this.triggerButtons[i].addEventListener('mouseleave', this['boundResetTimeout' + i], false);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Add more buttons for the event
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "add",
    value: function add(selectors) {
      var _this2 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'open';
      var i;
      var doc = document;
      var typeWithCapital = type.charAt(0).toUpperCase() + type.slice(1);

      if (selectors !== undefined) {
        var buttonsAlreadyThereLength = this[type + 'Buttons'].length;
        var newButtons = Array.prototype.slice.call(doc.querySelectorAll(selectors));
        var newButtonsLength = newButtons.length;

        for (i = 0; i < newButtonsLength; i++) {
          this[type + 'Buttons'].push(newButtons[i]);
        }

        var buttonsLength = this[type + 'Buttons'].length;

        for (i = buttonsAlreadyThereLength; i < buttonsLength; i++) {
          if (type === 'close') this['boundClose' + i] = function (e) {
            return _this2.instance.close({
              element: e,
              keepScrollDisabled: false
            });
          };else this['bound' + typeWithCapital + i] = function (e) {
            return _this2.instance[type](e);
          };
          this[type + 'Buttons'][i].addEventListener('mouseover', this['bound' + typeWithCapital + i], false);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Destroying all mouseover events
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "destroy",
    value: function destroy() {
      var i; // The open click event

      if (this.instance.overlay.mouseover.buttons.open !== undefined) {
        var openButtonsLength = this.openButtons.length;

        for (i = 0; i < openButtonsLength; i++) {
          this.openButtons[i].removeEventListener('mouseover', this['boundOpen' + i], false);
        }
      } // The close click event


      if (this.instance.overlay.mouseover.buttons.close !== undefined) {
        var closeButtonsLength = this.closeButtons.length;

        for (i = 0; i < closeButtonsLength; i++) {
          this.closeButtons[i].removeEventListener('mouseover', this['boundClose' + i], false);
        }
      } // The trigger click event


      if (this.instance.overlay.mouseover.buttons.trigger !== undefined) {
        var triggerButtonsLength = this.triggerButtons.length;

        for (i = 0; i < triggerButtonsLength; i++) {
          this.triggerButtons[i].removeEventListener('mouseover', this['boundTrigger' + i], false);
          this.triggerButtons[i].removeEventListener('mouseleave', this['boundResetTimeout' + i], false);
        }
      }
    }
  }]);

  return MouseoverEvent;
}();

/***/ }),

/***/ "./src/scripts/CustomEvents/ResizeEvent.js":
/*!*************************************************!*\
  !*** ./src/scripts/CustomEvents/ResizeEvent.js ***!
  \*************************************************/
/*! exports provided: ResizeEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResizeEvent", function() { return ResizeEvent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//---------------------------\\
//---- ResizeEvent Class ----\\
//---------------------------\\
var ResizeEvent = /*#__PURE__*/function () {
  function ResizeEvent(instance) {
    _classCallCheck(this, ResizeEvent);

    if (instance !== undefined) this.instance = instance;
    this.init();
  } // ----------------------------------------------------------------------------------------------------------------------------
  // Initialization of the resize event
  // ----------------------------------------------------------------------------------------------------------------------------


  _createClass(ResizeEvent, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.boundResize = function (e) {
        return _this.instance.resize(e);
      };

      window.addEventListener('resize', this.boundResize, true);
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Destroying the resize event
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener('resize', this.boundResize, true);
    }
  }]);

  return ResizeEvent;
}();

/***/ }),

/***/ "./src/scripts/CustomEvents/TimeoutEvent.js":
/*!**************************************************!*\
  !*** ./src/scripts/CustomEvents/TimeoutEvent.js ***!
  \**************************************************/
/*! exports provided: TimeoutEvent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimeoutEvent", function() { return TimeoutEvent; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//----------------------------\\
//---- TimeoutEvent class ----\\
//----------------------------\\
var TimeoutEvent = /*#__PURE__*/function () {
  function TimeoutEvent(instance) {
    _classCallCheck(this, TimeoutEvent);

    this.instance = instance;
    this.closeButtons = [];
  } // ----------------------------------------------------------------------------------------------------------------------------
  // Initialization of all timeout events
  // ----------------------------------------------------------------------------------------------------------------------------


  _createClass(TimeoutEvent, [{
    key: "init",
    value: function init() {
      var _this = this;

      var doc = document;
      var delay = this.instance.overlay.timeout.delay;

      if (this.instance.overlay.timeout.cookie == '') {
        this.timeout = setTimeout(function () {
          if (!doc.querySelector('html').classList.contains(_this.instance.overlay.structure.genericClass)) _this.instance.open();
        }, delay);
      } else {
        if (this.getCookie(this.instance.overlay.timeout.cookie) == '') {
          this.timeout = setTimeout(function () {
            if (!doc.querySelector('html').classList.contains(_this.instance.overlay.structure.genericClass)) {
              _this.instance.open();

              _this.setCookie(_this.instance.overlay.timeout.cookie, 'true', 7);
            }
          }, delay);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Destroying all timeout events
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this.timeout);
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Get the cookie that prevent the opening of the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "getCookie",
    value: function getCookie(cname) {
      var name = cname + '=';
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return '';
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Set the cookie that prevent the opening of the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "setCookie",
    value: function setCookie(name, value) {
      var exdays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var date = new Date();
      date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }
  }]);

  return TimeoutEvent;
}();

/***/ }),

/***/ "./src/scripts/CustomFunctions/getCubicBezier.js":
/*!*******************************************************!*\
  !*** ./src/scripts/CustomFunctions/getCubicBezier.js ***!
  \*******************************************************/
/*! exports provided: getCubicBezier */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCubicBezier", function() { return getCubicBezier; });
function getCubicBezier(easing) {
  var easingCode;
  if (easing === 'easeInSine') easingCode = '0.12, 0, 0.39, 0';else if (easing === 'easeOutSine') easingCode = '0.61, 1, 0.88, 1';else if (easing === 'easeInOutSine') easingCode = '0.37, 0, 0.63, 1';else if (easing === 'easeInQuad') easingCode = '0.11, 0, 0.5, 0';else if (easing === 'easeOutQuad') easingCode = '0.5, 1, 0.89, 1';else if (easing === 'easeInOutQuad') easingCode = '0.45, 0, 0.55, 1';else if (easing === 'easeInCubic') easingCode = '0.32, 0, 0.67, 0';else if (easing === 'easeOutCubic') easingCode = '0.33, 1, 0.68, 1';else if (easing === 'easeInOutCubic') easingCode = '0.65, 0, 0.35, 1';else if (easing === 'easeInQuart') easingCode = '0.5, 0, 0.75, 0';else if (easing === 'easeOutQuart') easingCode = '0.25, 1, 0.5, 1';else if (easing === 'easeInOutQuart') easingCode = '0.76, 0, 0.24, 1';else if (easing === 'easeInQuint') easingCode = '0.64, 0, 0.78, 0';else if (easing === 'easeOutQuint') easingCode = '0.22, 1, 0.36, 1';else if (easing === 'easeInOutQuint') easingCode = '0.83, 0, 0.17, 1';else if (easing === 'easeInExpo') easingCode = '0.7, 0, 0.84, 0';else if (easing === 'easeOutExpo') easingCode = '0.16, 1, 0.3, 1';else if (easing === 'easeInOutExpo') easingCode = '0.87, 0, 0.13, 1';else if (easing === 'easeInCirc') easingCode = '0.55, 0, 1, 0.45';else if (easing === 'easeOutCirc') easingCode = '0, 0.55, 0.45, 1';else if (easing === 'easeInOutCirc') easingCode = '0.85, 0, 0.15, 1';else if (easing === 'easeInBack') easingCode = '0.36, 0, 0.66, -0.56';else if (easing === 'easeOutBack') easingCode = '0.34, 1.56, 0.64, 1';else if (easing === 'easeInOutBack') easingCode = '0.68, -0.6, 0.32, 1.6';
  return 'cubic-bezier(' + easingCode + ')';
}

/***/ }),

/***/ "./src/scripts/CustomFunctions/getDatasetHeight.js":
/*!*********************************************************!*\
  !*** ./src/scripts/CustomFunctions/getDatasetHeight.js ***!
  \*********************************************************/
/*! exports provided: getDatasetHeight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDatasetHeight", function() { return getDatasetHeight; });
function getDatasetHeight(selector) {
  var i,
      height = 0;
  var children = selector.children;
  var childrenLength = children.length;

  for (i = 0; i < childrenLength; i++) {
    if (children[i].dataset.section === document.querySelector('html').dataset.section) height = children[i].offsetHeight;
  }

  return height + 'px';
}

/***/ }),

/***/ "./src/scripts/CustomFunctions/getElementOffset.js":
/*!*********************************************************!*\
  !*** ./src/scripts/CustomFunctions/getElementOffset.js ***!
  \*********************************************************/
/*! exports provided: getElementOffset */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementOffset", function() { return getElementOffset; });
function getElementOffset(element) {
  var box = document.querySelector(element).getBoundingClientRect();
  var body = document.body;
  var docEl = document.documentElement;
  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;
  return {
    top: Math.round(top),
    left: Math.round(left)
  };
}

/***/ }),

/***/ "./src/scripts/CustomFunctions/getMaxHeight.js":
/*!*****************************************************!*\
  !*** ./src/scripts/CustomFunctions/getMaxHeight.js ***!
  \*****************************************************/
/*! exports provided: getMaxHeight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMaxHeight", function() { return getMaxHeight; });
function getMaxHeight(selector) {
  var i,
      height = 0;
  var children = selector.children;
  var childrenLength = children.length;

  for (i = 0; i < childrenLength; i++) {
    height += children[i].clientHeight;
  }

  return "".concat(height, "px");
}

/***/ }),

/***/ "./src/scripts/CustomFunctions/getObjectSize.js":
/*!******************************************************!*\
  !*** ./src/scripts/CustomFunctions/getObjectSize.js ***!
  \******************************************************/
/*! exports provided: getObjectSize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObjectSize", function() { return getObjectSize; });
function getObjectSize(o) {
  var s = 0,
      key;

  for (key in o) {
    if (o.hasOwnProperty(key)) s++;
  }

  return s;
}

/***/ }),

/***/ "./src/scripts/CustomFunctions/getTallestChild.js":
/*!********************************************************!*\
  !*** ./src/scripts/CustomFunctions/getTallestChild.js ***!
  \********************************************************/
/*! exports provided: getTallestChild */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTallestChild", function() { return getTallestChild; });
function getTallestChild(selector) {
  var i,
      height = 0;
  var children = selector.children;
  var childrenLength = children.length;

  for (i = 0; i < childrenLength; i++) {
    if (height < children[i].scrollHeight) height = children[i].scrollHeight;
  }

  return height + 'px';
}

/***/ }),

/***/ "./src/scripts/Debug.js":
/*!******************************!*\
  !*** ./src/scripts/Debug.js ***!
  \******************************/
/*! exports provided: Debug */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Debug", function() { return Debug; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//---------------------\\
//---- Debug class ----\\
//---------------------\\
var Debug = /*#__PURE__*/function () {
  function Debug(instance) {
    _classCallCheck(this, Debug);

    this.instance = instance.overlay;
    this.instance.hasError = false;
    this.error = '';
  } // Check for errors


  _createClass(Debug, [{
    key: "init",
    value: function init() {
      var root = this.instance.options.root;
      this.instanceElement = root.querySelector('[data-overlay=' + this.instance.name + ']');
      this.instanceLength = root.querySelectorAll('[data-overlay=' + this.instance.name + ']').length;
      if (this.instance.name === 'undefined') this.getMessage('missingName');else if (this.instanceLength < 1) this.getMessage('missingElement');else if (this.instanceElement.classList.contains('overlay-initialized')) this.getMessage('alreadyInitialized');else if (Object.keys(this.instance.click.buttons).length === 0 && Object.keys(this.instance.mouseover.buttons).length === 0 && Object.keys(this.instance.timeout.buttons).length === 0) this.getMessage('missingEvent');else if (this.instanceLength > 1) this.getMessage('duplicate');else if (this.instanceLength < 1) this.getMessage('nothing');
      if (this.error !== '') this.instance.hasError = true;
    } // Construct the error message

  }, {
    key: "getMessage",
    value: function getMessage(error) {
      var obj = {
        missingName: 'You must provide a name to your overlay',
        missingElement: 'You must provide an element with the attribute "data-overlay" that has the name is the value',
        alreadyInitialized: 'The overlay has already been initialized',
        missingEvent: 'You must provide at least one event among the following: click, mouseover or timeout',
        duplicate: 'The website must have a unique instance of the overlay, you have have currently ' + this.instanceLength + ' instances of the same overlay',
        nothing: 'The website must have at least 1 instance of the overlay'
      };

      if (this.instance.name !== 'undefined') {
        this.error = 'OVERLAY.JS -> The overlay ' + this.instance.name + ': ' + obj[error];
      } else {
        this.error = 'OVERLAY.JS -> ' + obj[error];
      }
    } // Return if there is an error

  }, {
    key: "hasError",
    value: function hasError() {
      return this.instance.hasError;
    } // Return the error

  }, {
    key: "getError",
    value: function getError() {
      return this.error;
    }
  }]);

  return Debug;
}();

/***/ }),

/***/ "./src/scripts/Overlay.js":
/*!********************************!*\
  !*** ./src/scripts/Overlay.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Overlay; });
/* harmony import */ var _styles_styles_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../styles/styles.scss */ "./src/styles/styles.scss");
/* harmony import */ var _styles_styles_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_styles_styles_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CustomEvents_ClickEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CustomEvents/ClickEvent.js */ "./src/scripts/CustomEvents/ClickEvent.js");
/* harmony import */ var _CustomEvents_MouseoverEvent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CustomEvents/MouseoverEvent.js */ "./src/scripts/CustomEvents/MouseoverEvent.js");
/* harmony import */ var _CustomEvents_TimeoutEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CustomEvents/TimeoutEvent.js */ "./src/scripts/CustomEvents/TimeoutEvent.js");
/* harmony import */ var _CustomEvents_ResizeEvent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CustomEvents/ResizeEvent.js */ "./src/scripts/CustomEvents/ResizeEvent.js");
/* harmony import */ var _Debug_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Debug.js */ "./src/scripts/Debug.js");
/* harmony import */ var _CustomFunctions_getElementOffset_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CustomFunctions/getElementOffset.js */ "./src/scripts/CustomFunctions/getElementOffset.js");
/* harmony import */ var _CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CustomFunctions/getObjectSize.js */ "./src/scripts/CustomFunctions/getObjectSize.js");
/* harmony import */ var _CustomFunctions_getMaxHeight_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CustomFunctions/getMaxHeight.js */ "./src/scripts/CustomFunctions/getMaxHeight.js");
/* harmony import */ var _CustomFunctions_getTallestChild_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CustomFunctions/getTallestChild.js */ "./src/scripts/CustomFunctions/getTallestChild.js");
/* harmony import */ var _CustomFunctions_getDatasetHeight_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CustomFunctions/getDatasetHeight.js */ "./src/scripts/CustomFunctions/getDatasetHeight.js");
/* harmony import */ var _CustomFunctions_getCubicBezier_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CustomFunctions/getCubicBezier.js */ "./src/scripts/CustomFunctions/getCubicBezier.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//-----------------------\\
//---- Overlay class ----\\
//-----------------------\\
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Class that create overlay (popup, sidepanel, others)
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Importation ----------------------------------------------------------------------------------------------------











 //-----------------------------------------------------------------------------------------------------------------

var Overlay = /*#__PURE__*/function () {
  // ----------------------------------------------------------------------------------------------------------------------------
  // constructor
  // ----------------------------------------------------------------------------------------------------------------------------
  function Overlay(object) {
    _classCallCheck(this, Overlay);

    this.overlay = object;
    this.setDefault();
    this.debug = new _Debug_js__WEBPACK_IMPORTED_MODULE_5__["Debug"](this);
  } // ----------------------------------------------------------------------------------------------------------------------------
  // Set all default value of the class
  // ----------------------------------------------------------------------------------------------------------------------------


  _createClass(Overlay, [{
    key: "setDefault",
    value: function setDefault() {
      if (this.overlay.structure === undefined) this.overlay.structure = {};
      if (this.overlay.create === undefined) this.overlay.create = {};
      if (this.overlay.events === undefined) this.overlay.events = {};
      if (this.overlay.click === undefined) this.overlay.click = {};
      if (this.overlay.click.buttons === undefined) this.overlay.click.buttons = {};
      if (this.overlay.mouseover === undefined) this.overlay.mouseover = {};
      if (this.overlay.mouseover.buttons === undefined) this.overlay.mouseover.buttons = {};
      if (this.overlay.timeout === undefined) this.overlay.timeout = {};
      if (this.overlay.options === undefined) this.overlay.options = {};
      if (this.overlay.structure.container === undefined) this.overlay.structure.container = 'html';
      if (this.overlay.structure.genericClass === undefined) this.overlay.structure.genericClass = 'show-overlay';
      if (this.overlay.structure.dataset === undefined) this.overlay.structure.dataset = 'section';
      if (this.overlay.create.container === undefined) this.overlay.create.container = true;
      if (this.overlay.create.close === undefined) this.overlay.create.close = true;
      if (this.overlay.create.background === undefined) this.overlay.create.background = true;
      if (this.overlay.events.init === undefined) this.overlay.events.init = false;
      if (this.overlay.events.open === undefined) this.overlay.events.open = false;
      if (this.overlay.events.openComplete === undefined) this.overlay.events.openComplete = false;
      if (this.overlay.events.close === undefined) this.overlay.events.close = false;
      if (this.overlay.events.closeComplete === undefined) this.overlay.events.closeComplete = false;
      if (this.overlay.timeout.delay === undefined) this.overlay.timeout.delay = 0;
      if (this.overlay.timeout.cookie === undefined) this.overlay.timeout.cookie = '';
      if (this.overlay.options.root === undefined) this.overlay.options.root = document;
      if (this.overlay.options.speed === undefined) this.overlay.options.speed = 600;
      if (this.overlay.options.goToSelector === undefined) this.overlay.options.goToSelector = '';
      if (this.overlay.options.global === undefined) this.overlay.options.global = false;
      if (this.overlay.options.disabledPageScroll === undefined) this.overlay.options.disabledPageScroll = true;
      if (this.overlay.options.closeOnResize === undefined) this.overlay.options.closeOnResize = true;
      if (this.overlay.options.override === undefined) this.overlay.options.override = false;

      if (this.overlay.name !== undefined) {
        this.overlay.name = this.overlay.name.charAt(0).toLowerCase() + this.overlay.name.slice(1);
        if (this.overlay.structure.id === undefined) this.overlay.structure.id = "overlay-".concat(this.overlay.name);
        if (this.overlay.structure.activeClass === undefined) this.overlay.structure.activeClass = "show-overlay-".concat(this.overlay.name);
        if (this.overlay.structure.openingClass === undefined) this.overlay.structure.openingClass = "opening-overlay-".concat(this.overlay.name);
        if (this.overlay.structure.closingClass === undefined) this.overlay.structure.closingClass = "closing-overlay-".concat(this.overlay.name);
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Initialization of the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "init",
    value: function init() {
      this.debug.init();

      if (this.debug.hasError()) {
        console.log(this.debug.getError());
      } else {
        // Variable assignment
        var root = this.overlay.options.root;
        var capitalizedName = this.overlay.name.charAt(0).toUpperCase() + this.overlay.name.slice(1);
        this.timeout; // mouseover delay timeout

        this.status = 'close'; // overlay status

        this.initialHTML = root.querySelector("[data-overlay=".concat(this.overlay.name, "]")).outerHTML; // Initial HTML of the overlay

        this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight; // Creation of the callback events

        if (this.overlay.events.init) this.initEvent = new CustomEvent("onInitOverlay".concat(capitalizedName));
        if (this.overlay.events.open) this.openEvent = new CustomEvent("onOpenOverlay".concat(capitalizedName));
        if (this.overlay.events.openComplete) this.openCompleteEvent = new CustomEvent("onOpenCompleteOverlay".concat(capitalizedName));
        if (this.overlay.events.close) this.closeEvent = new CustomEvent("onCloseOverlay".concat(capitalizedName));
        if (this.overlay.events.closeComplete) this.closeCompleteEvent = new CustomEvent("onCloseCompleteOverlay".concat(capitalizedName)); // Put the overlay in the window object

        if (this.overlay.options.global) window.overlay[this.overlay.name] = this; // Put the overlay in a global array

        Overlay.instances.push(this); // create the events for the overlay

        this.clickEvent = new _CustomEvents_ClickEvent_js__WEBPACK_IMPORTED_MODULE_1__["ClickEvent"](this);
        this.mouseoverEvent = new _CustomEvents_MouseoverEvent_js__WEBPACK_IMPORTED_MODULE_2__["MouseoverEvent"](this);
        this.timeoutEvent = new _CustomEvents_TimeoutEvent_js__WEBPACK_IMPORTED_MODULE_3__["TimeoutEvent"](this); // Create the html structure of the overlay

        this.create(); // Prepare the animations

        this.prepareAnimations(); // Enable the close on resize

        if (this.overlay.options.closeOnResize) this.resizeEvent = new _CustomEvents_ResizeEvent_js__WEBPACK_IMPORTED_MODULE_4__["ResizeEvent"](this); // Dispatch the events for the overlay

        if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(this.overlay.click.buttons) > 0) this.clickEvent.init();
        if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(this.overlay.mouseover.buttons) > 0) this.mouseoverEvent.init();
        if (this.overlay.timeout.delay > 0) this.timeoutEvent.init();
        if (this.overlay.events.init) dispatchEvent(this.initEvent);
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Create the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "create",
    value: function create() {
      var root = this.overlay.options.root;
      var overlay = root.querySelector("[data-overlay=".concat(this.overlay.name, "]"));
      overlay.classList.add('overlay-initialized');
      overlay.setAttribute('id', this.overlay.structure.id);
      var close, x;

      if (this.overlay.create.close) {
        close = document.createElement('div');
        x = document.createElement('div');
        close.appendChild(x);
        close.setAttribute('class', "overlay-".concat(this.overlay.name, "__close"));
      }

      var container;

      if (this.overlay.create.container) {
        var innerHTML = overlay.innerHTML;
        container = document.createElement('div');
        container.setAttribute('class', "overlay-".concat(this.overlay.name, "__container"));
        overlay.innerHTML = '';
        container.innerHTML = innerHTML;
        if (this.overlay.create.close) container.appendChild(close);
        overlay.appendChild(container);
      } else {
        if (this.overlay.create.close) overlay.appendChild(close);
      }

      this.clickEvent.add("#".concat(this.overlay.structure.id, " .overlay-").concat(this.overlay.name, "__close"), 'close');
      var background;

      if (this.overlay.create.background) {
        background = document.createElement('div');
        background.setAttribute('class', "overlay-".concat(this.overlay.name, "__background background"));
        overlay.appendChild(background);
        if (this.overlay.mouseover.buttons.open !== undefined || this.overlay.mouseover.buttons.trigger !== undefined) this.mouseoverEvent.add("#".concat(this.overlay.structure.id, " .overlay-").concat(this.overlay.name, "__background"), 'close');else this.clickEvent.add("#".concat(this.overlay.structure.id, " .overlay-").concat(this.overlay.name, "__background"), 'close');
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Open the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "open",
    value: function open() {
      var _this = this;

      // Variable assignment
      var doc = document;
      var html = doc.querySelector('html');
      var container = doc.querySelector(this.overlay.structure.container);
      var speed = this.overlay.options.openingSpeed !== undefined ? this.overlay.options.openingSpeed : this.overlay.options.speed; // If it's not opened, open it

      if (this.status === 'close') {
        // Switch the status of the overlay to opened
        this.status = 'open'; // start opening animation

        if (this.isAnimations) this.animate(); // Cancel the closing for the opening

        if (container.classList.contains(this.overlay.structure.closingClass)) {
          clearTimeout(this.closingTimeout);
          if (!this.overlay.options.override) container.classList.remove(this.overlay.structure.genericClass);
          container.classList.remove(this.overlay.structure.activeClass);
          container.classList.remove(this.overlay.structure.closingClass);
        } // Scroll to the container given if there's one


        if (this.overlay.options.goToSelector !== '') html.scrollTop = Object(_CustomFunctions_getElementOffset_js__WEBPACK_IMPORTED_MODULE_6__["getElementOffset"])(this.overlay.options.goToSelector).top; // Add the no scroll if the option is on

        if (this.overlay.options.disabledPageScroll) this.disablePageScroll(); // Dispatch a custom event on the opening

        if (this.overlay.events.open) dispatchEvent(this.openEvent); // No generic class if the overlay can be opened with another one

        if (!this.overlay.options.override) container.classList.add(this.overlay.structure.genericClass); // Add active and opening classes

        container.classList.add(this.overlay.structure.openingClass);
        container.classList.add(this.overlay.structure.activeClass); // Remove the opening class when the opening is done

        this.openingTimeout = setTimeout(function () {
          if (_this.overlay.events.openComplete) dispatchEvent(_this.openCompleteEvent);
          container.classList.remove(_this.overlay.structure.openingClass);
        }, speed);
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Close the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "close",
    value: function close() {
      var _this2 = this;

      var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Variable assignment
      var doc = document;
      var container = doc.querySelector(this.overlay.structure.container);
      var speed = this.overlay.options.closingSpeed !== undefined ? this.overlay.options.closingSpeed : this.overlay.options.speed;
      var keepScrollDisabled = object.keepScrollDisabled !== undefined ? object.keepScrollDisabled : false; // If it's not closed, close it

      if (this.status === 'open') {
        // Switch the status of the overlay to opened
        this.status = 'close'; // Remove the dataset trigger on close

        if (this.overlay.structure.dataset !== undefined && !keepScrollDisabled) container.dataset[this.overlay.structure.dataset] = ''; // start closing animation

        if (this.isAnimations) this.animate(); // Cancel the opening for the closing

        if (container.classList.contains(this.overlay.structure.openingClass)) {
          clearTimeout(this.openingTimeout);
          container.classList.remove(this.overlay.structure.openingClass);
        } // Remove the no scroll if the option is on


        if (this.overlay.options.disabledPageScroll && !keepScrollDisabled) this.enablePageScroll(); // Dispatch a custom event on the closing

        if (this.overlay.events.close) dispatchEvent(this.closeEvent); // Add the closing class

        container.classList.add(this.overlay.structure.closingClass); // Remove the closing class when the closing is done

        this.closingTimeout = setTimeout(function () {
          if (_this2.overlay.events.closeComplete) dispatchEvent(_this2.closeCompleteEvent);
          if (!keepScrollDisabled && !_this2.overlay.options.override) container.classList.remove(_this2.overlay.structure.genericClass);
          container.classList.remove(_this2.overlay.structure.activeClass);
          container.classList.remove(_this2.overlay.structure.closingClass);
        }, speed);
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Trigger the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "trigger",
    value: function trigger(e) {
      var _this3 = this;

      var doc = document;
      var container = doc.querySelector(this.overlay.structure.container);
      var targetDataset = typeof e === 'string' ? e : e.currentTarget.dataset[this.overlay.structure.dataset]; // if the target has a dataset to trigger and the overlay is opened

      if (targetDataset !== undefined) {
        if (container.classList.contains(this.overlay.structure.activeClass) && !container.classList.contains(this.overlay.structure.closingClass)) {
          if (targetDataset === container.dataset[this.overlay.structure.dataset] && this.overlay.click.buttons.trigger !== undefined) {
            this.close({
              element: e,
              keepScrollDisabled: false
            });
            container.dataset[this.overlay.structure.dataset] = '';
          } else {
            if (this.overlay.mouseover.delay !== undefined && container.dataset[this.overlay.structure.dataset] !== '') {
              this.timeout = setTimeout(function () {
                container.dataset[_this3.overlay.structure.dataset] = targetDataset;
                if (_this3.isAnimations) _this3.animate();
              }, this.overlay.mouseover.delay);
            } else {
              container.dataset[this.overlay.structure.dataset] = targetDataset;
              if (this.isAnimations) this.animate();
            }
          }
        } else {
          container.dataset[this.overlay.structure.dataset] = targetDataset;
          this.open(e);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Toggle the opening and the closing
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "toggle",
    value: function toggle(e) {
      var doc = document;
      var container = doc.querySelector(this.overlay.structure.container);
      var hasActiveClass = container.classList.contains(this.overlay.structure.activeClass);
      var hasClosingClass = container.classList.contains(this.overlay.structure.closingClass);
      if (!hasActiveClass || hasClosingClass) this.open(e);else this.close({
        element: e,
        keepScrollDisabled: false
      });
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Switch to another overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "switch",
    value: function _switch(e) {
      var container = document.querySelector(this.overlay.structure.container);
      if (container.classList.contains(this.overlay.structure.activeClass)) this.close({
        element: e,
        keepScrollDisabled: true
      });
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Close the overlay on resize if the option is on
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "resize",
    value: function resize(e) {
      var newWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      var newHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      if (newWidth !== this.windowWidth || newHeight !== this.windowHeight) {
        this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        this.close({
          element: e,
          keepScrollDisabled: false
        });
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Animate some properties given in the Overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "prepareAnimations",
    value: function prepareAnimations() {
      this.isAnimations = false;

      if (typeof this.overlay.animations !== 'undefined') {
        var i, elementToAnimate, stylesLength;
        this.isAnimations = true;
        if (!this.overlay.create.container) elementToAnimate = "#".concat(this.overlay.structure.id);else elementToAnimate = "#".concat(this.overlay.structure.id, " > .overlay-").concat(this.overlay.name, "__container");
        this.overlay.animations.element = document.querySelector(elementToAnimate);
        stylesLength = this.overlay.animations.styles.length;

        for (i = 0; i < stylesLength; i++) {
          if (this.overlay.animations.styles[i].easing !== undefined) this.overlay.animations.styles[i].easing = Object(_CustomFunctions_getCubicBezier_js__WEBPACK_IMPORTED_MODULE_11__["getCubicBezier"])(this.overlay.animations.styles[i].easing);
        }
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Animate some properties given in the Overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "animate",
    value: function animate() {
      var i,
          speed,
          element = this.overlay.animations.element,
          styles = this.overlay.animations.styles,
          stylesLength = styles.length,
          transitionString = '';
      if (this.status === 'open') speed = this.overlay.options.openingSpeed !== undefined ? this.overlay.options.openingSpeed : this.overlay.options.speed;else speed = this.overlay.options.closingSpeed !== undefined ? this.overlay.options.closingSpeed : this.overlay.options.speed;

      for (i = 0; i < stylesLength; i++) {
        if (styles[i].property === 'height' && styles[i].value === 'tallestChild') element.style.height = this.status === 'open' ? Object(_CustomFunctions_getTallestChild_js__WEBPACK_IMPORTED_MODULE_9__["getTallestChild"])(element) : '';else if (styles[i].property === 'height' && styles[i].value === 'dataset') element.style.height = this.status === 'open' ? Object(_CustomFunctions_getDatasetHeight_js__WEBPACK_IMPORTED_MODULE_10__["getDatasetHeight"])(element) : '';else if (styles[i].property === 'height' && styles[i].value === '100%') element.style.height = this.status === 'open' ? Object(_CustomFunctions_getMaxHeight_js__WEBPACK_IMPORTED_MODULE_8__["getMaxHeight"])(element) : '';else element.style[styles[i].property] = this.status === 'open' ? styles[i].value : '';

        if (this.overlay.animations.addTransition) {
          transitionString += "".concat((i !== 0 ? ', ' : ' ') + styles[i].property, " ");
          transitionString += this.status === 'open' ? "".concat(speed, "ms ") : '300ms';
          if (styles[i].easing !== undefined) transitionString += styles[i].easing;
        }
      }

      if (this.overlay.animations.addTransition) element.style.transition = transitionString;
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Reset the timeout of the triggering delay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "resetTimeout",
    value: function resetTimeout() {
      clearTimeout(this.timeout);
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Add the no scroll to the page. The user can no longer scroll
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "disablePageScroll",
    value: function disablePageScroll() {
      var doc = document;
      var html = doc.querySelector('html');
      var scrollTop = "".concat(-html.scrollTop, "px");
      html.classList.add('disabled-page-scroll');
      html.style.top = scrollTop;
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Remove the no scroll to the page. The user can scroll again in the page
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "enablePageScroll",
    value: function enablePageScroll() {
      var doc = document;
      var html = doc.querySelector('html');

      if (this.overlay.options.goToSelector !== '') {
        html.classList.remove('disabled-page-scroll');
        html.scrollTop = Object(_CustomFunctions_getElementOffset_js__WEBPACK_IMPORTED_MODULE_6__["getElementOffset"])(this.overlay.options.goToSelector).top;
      } else {
        var scrollPosition = parseInt(html.style.top);
        html.classList.remove('disabled-page-scroll');
        html.scrollTop = -scrollPosition;
      }
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Destroy the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "destroy",
    value: function destroy() {
      var root = this.overlay.options.root;
      var overlay = root.querySelector("[data-overlay=".concat(this.overlay.name, "]"));
      overlay.classList.remove('overlay-initialized'); // Remove the instance from the Variable Overlay.instance

      var index = Overlay.instances.indexOf(this);

      if (index > -1) {
        Overlay.instances.splice(index, 1);
      } // Remove the instance from the window object


      if (this.overlay.options.global) window.overlay[this.overlay.name] = undefined; // Destroy all events

      if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(this.overlay.click.buttons) > 0) this.clickEvent.destroy();
      if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(this.overlay.mouseover.buttons) > 0) this.mouseoverEvent.destroy();
      if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(this.overlay.timeout.buttons) > 0 && root.querySelectorAll("#".concat(this.overlay.structure.id)).length != 0) this.timeoutEvent.destroy();
      if (this.overlay.options.closeOnResize) this.resizeEvent.destroy();
      root.querySelector("[data-overlay=".concat(this.overlay.name, "]")).outerHTML = this.initialHTML;
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Destroy all overlays
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "getStatus",
    // ----------------------------------------------------------------------------------------------------------------------------
    // Return the status
    // ----------------------------------------------------------------------------------------------------------------------------
    value: function getStatus() {
      return this.status;
    }
  }], [{
    key: "destroyAll",
    value: function destroyAll() {
      var i;
      var doc = document;
      var overlaysLength = Overlay.instances.length;

      for (i = 0; i < overlaysLength; i++) {
        if (Overlay.instances[i].getStatus() === 'open') Overlay.instances[i].close();
        if (Overlay.instances[i].overlay.options.global) window.overlay[Overlay.instances[i].overlay.name] = undefined;
        if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(Overlay.instances[i].overlay.click.buttons) > 0) Overlay.instances[i].clickEvent.destroy();
        if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(Overlay.instances[i].overlay.mouseover.buttons) > 0) Overlay.instances[i].mouseoverEvent.destroy();
        if (Object(_CustomFunctions_getObjectSize_js__WEBPACK_IMPORTED_MODULE_7__["getObjectSize"])(Overlay.instances[i].overlay.timeout.buttons) > 0 && doc.querySelectorAll("#".concat(Overlay.instances[i].overlay.structure.id)).length != 0) Overlay.instances[i].timeoutEvent.destroy();
        if (Overlay.instances[i].overlay.options.closeOnResize) Overlay.instances[i].resizeEvent.destroy();
        doc.querySelector("[data-overlay=".concat(Overlay.instances[i].overlay.name, "]")).outerHTML = Overlay.instances[i].initialHTML;
        doc.querySelector("[data-overlay=".concat(Overlay.instances[i].overlay.name, "]")).classList.remove('overlay-initialized');
      }

      Overlay.instances = [];
    } // ----------------------------------------------------------------------------------------------------------------------------
    // Return the overlay
    // ----------------------------------------------------------------------------------------------------------------------------

  }, {
    key: "getOverlay",
    value: function getOverlay(overlay) {
      var i;
      var overlaysLength = Overlay.instances.length;
      var overlayObj;

      for (i = 0; i < overlaysLength; i++) {
        if (Overlay.instances[i].overlay.name === overlay) overlayObj = Overlay.instances[i];
      }

      return overlayObj;
    }
  }]);

  return Overlay;
}();


Overlay.instances = [];

/***/ }),

/***/ "./src/scripts/index.js":
/*!******************************!*\
  !*** ./src/scripts/index.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Overlay = __webpack_require__(/*! ./Overlay */ "./src/scripts/Overlay.js").default;

module.exports = Overlay;

/***/ }),

/***/ "./src/styles/styles.scss":
/*!********************************!*\
  !*** ./src/styles/styles.scss ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });
});